import { render, staticRenderFns } from "./recordControlList.vue?vue&type=template&id=ac21b380&scoped=true&"
import script from "./recordControlList.vue?vue&type=script&lang=ts&"
export * from "./recordControlList.vue?vue&type=script&lang=ts&"
import style0 from "./recordControlList.vue?vue&type=style&index=0&id=ac21b380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac21b380",
  null
  
)

export default component.exports